"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoidUploader = exports.UploadState = void 0;
const sjcl_1 = __importDefault(require("sjcl"));
const codecBytes_1 = require("./codecBytes");
const utils_1 = require("./utils");
/**
 * Generic upload state
 */
var UploadState;
(function (UploadState) {
    UploadState[UploadState["NotStarted"] = 0] = "NotStarted";
    UploadState[UploadState["Starting"] = 1] = "Starting";
    UploadState[UploadState["Hashing"] = 2] = "Hashing";
    UploadState[UploadState["Uploading"] = 3] = "Uploading";
    UploadState[UploadState["Done"] = 4] = "Done";
    UploadState[UploadState["Failed"] = 5] = "Failed";
    UploadState[UploadState["Challenge"] = 6] = "Challenge";
})(UploadState = exports.UploadState || (exports.UploadState = {}));
/**
 * Base file uploader class
 */
class VoidUploader {
    constructor(uri, file, stateChange, progress, proxyChallenge, auth, chunkSize) {
        this.uri = uri;
        this.file = file;
        this.onStateChange = stateChange;
        this.onProgress = progress;
        this.onProxyChallenge = proxyChallenge;
        this.auth = auth;
        this.maxChunkSize = chunkSize ?? Number.MAX_VALUE;
    }
    /**
     * SHA-256 hash the entire blob
     * @param file
     * @protected
     */
    async digest(file) {
        const ChunkSize = 1024 * 1024;
        // must compute hash in chunks, subtle crypto cannot hash files > 2Gb
        const sha = new sjcl_1.default.hash.sha256();
        let progress = 0;
        for (let x = 0; x < Math.ceil(file.size / ChunkSize); x++) {
            const offset = x * ChunkSize;
            const slice = file.slice(offset, offset + ChunkSize);
            const chunk = await slice.arrayBuffer();
            sha.update(codecBytes_1.sjclcodec.toBits(new Uint8Array(chunk)));
            this.onProgress?.(progress += chunk.byteLength);
        }
        return (0, utils_1.buf2hex)(codecBytes_1.sjclcodec.fromBits(sha.finalize()));
    }
}
exports.VoidUploader = VoidUploader;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXBsb2FkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3VwbG9hZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFDQSxnREFBd0I7QUFDeEIsNkNBQXlDO0FBQ3pDLG1DQUFrQztBQUNsQzs7R0FFRztBQUNILElBQVksV0FRWDtBQVJELFdBQVksV0FBVztJQUNuQix5REFBVSxDQUFBO0lBQ1YscURBQVEsQ0FBQTtJQUNSLG1EQUFPLENBQUE7SUFDUCx1REFBUyxDQUFBO0lBQ1QsNkNBQUksQ0FBQTtJQUNKLGlEQUFNLENBQUE7SUFDTix1REFBUyxDQUFBO0FBQ2IsQ0FBQyxFQVJXLFdBQVcsR0FBWCxtQkFBVyxLQUFYLG1CQUFXLFFBUXRCO0FBTUQ7O0dBRUc7QUFDSCxNQUFzQixZQUFZO0lBUzlCLFlBQ0ksR0FBVyxFQUNYLElBQWlCLEVBQ2pCLFdBQWdDLEVBQ2hDLFFBQTBCLEVBQzFCLGNBQXNDLEVBQ3RDLElBQWEsRUFDYixTQUFrQjtRQUVsQixJQUFJLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQztRQUNmLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDO1FBQ2pCLElBQUksQ0FBQyxhQUFhLEdBQUcsV0FBVyxDQUFDO1FBQ2pDLElBQUksQ0FBQyxVQUFVLEdBQUcsUUFBUSxDQUFDO1FBQzNCLElBQUksQ0FBQyxnQkFBZ0IsR0FBRyxjQUFjLENBQUM7UUFDdkMsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUM7UUFDakIsSUFBSSxDQUFDLFlBQVksR0FBRyxTQUFTLElBQUksTUFBTSxDQUFDLFNBQVMsQ0FBQztJQUN0RCxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNPLEtBQUssQ0FBQyxNQUFNLENBQUMsSUFBVTtRQUM3QixNQUFNLFNBQVMsR0FBRyxJQUFJLEdBQUcsSUFBSSxDQUFDO1FBRTlCLHFFQUFxRTtRQUNyRSxNQUFNLEdBQUcsR0FBRyxJQUFJLGNBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxFQUFFLENBQUM7UUFDbkMsSUFBSSxRQUFRLEdBQUcsQ0FBQyxDQUFDO1FBQ2pCLEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLEdBQUcsU0FBUyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7WUFDdkQsTUFBTSxNQUFNLEdBQUcsQ0FBQyxHQUFHLFNBQVMsQ0FBQztZQUM3QixNQUFNLEtBQUssR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sRUFBRSxNQUFNLEdBQUcsU0FBUyxDQUFDLENBQUM7WUFDckQsTUFBTSxLQUFLLEdBQUcsTUFBTSxLQUFLLENBQUMsV0FBVyxFQUFFLENBQUM7WUFDeEMsR0FBRyxDQUFDLE1BQU0sQ0FBQyxzQkFBUyxDQUFDLE1BQU0sQ0FBQyxJQUFJLFVBQVUsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDcEQsSUFBSSxDQUFDLFVBQVUsRUFBRSxDQUFDLFFBQVEsSUFBSSxLQUFLLENBQUMsVUFBVSxDQUFDLENBQUM7U0FDbkQ7UUFDRCxPQUFPLElBQUEsZUFBTyxFQUFDLHNCQUFTLENBQUMsUUFBUSxDQUFDLEdBQUcsQ0FBQyxRQUFRLEVBQUUsQ0FBQyxDQUFDLENBQUM7SUFDdkQsQ0FBQztDQXNCSjtBQXBFRCxvQ0FvRUMifQ==